import { AvailableProviders } from '@/utils/constants/providers/availableProviders'

export const CATEGORIES_OVERRIDE_PROVIDERS = [
  AvailableProviders.Apple,
  AvailableProviders.Bing,
  AvailableProviders.Facebook,
  AvailableProviders.Google,
  AvailableProviders.Yelp,
] as const

export type CategoriesOverrideProvidersType = (typeof CATEGORIES_OVERRIDE_PROVIDERS)[number]
